// Modal.js
import { Modal, Button } from "react-bootstrap";
import * as React from "react";
import modalLogo from "../../Assets/images/logoh.png";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  checkLoginStatus,
  login,
  loginUser,
  verifyUser,
} from "../../StateManagement/authSlice";
import Cookies from "js-cookie";
import axios from "axios";
import { Api, BASE_URL } from "./Api/Api";
import PrivacyModal from "../../Components/PrivacyModal";

const CustomModal = ({ isOpen, closeModal, onExit, onExited, onLogin }) => {
  const [isLogin, setIslogin] = useState(false);
  const [loginMessage, setLoginMessage] = useState("");
  const [loginStatusMessage, setLoginStatusMessage] = useState("");
  const loginRef = useRef();
  const verifyRef = useRef();
  const [credentials, setCredentials] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen) {
      loginRef.current.focus();
      if (isLogin) {
        verifyRef.current.focus();
      }
    }
  }, [isLogin,isOpen]);
  const handleLogin = async (info) => {
    const bodyFormData = new FormData();
    if (Cookies.get("rt")) {
      bodyFormData.append("rt", Cookies.get("rt"));
    }
    bodyFormData.append("mob", credentials);
    const response = await axios.post(BASE_URL, bodyFormData, {
      headers: {
        "Content-type": "multipart/form-data",
        Accept: "application/json",
        cmd: "login",
      },
    });
    if (response.status === 200) {
      const data = await response.data?.login;
      handleResponse(response.data?.login);
      return data;
    } else {
      console.error(`API request failed with status: ${response.status}`);
    }
  };

  const handleResponse = (response) => {
    switch (response?.code) {
      case 1: {
        setIslogin(true);
        setLoginMessage("");
        setLoginStatusMessage(response?.msg);
        break;
      }
      case -1: {
        setIslogin(false);
        setLoginMessage(response?.msg);
        break;
      }
      case 0: {
        setIslogin(true);
        setLoginMessage("");
        setLoginStatusMessage(response?.msg);
        break;
      }
    }
  };
  const handleVerification = async (value) => {
    const data = {
      number: credentials,
      otp: value,
    };
    if (value.length >= 4) {
      const bodyFormData = new FormData();
      console.log(Cookies.get("rt"));
      if (Cookies.get("rt")) {
        bodyFormData.append("rt", Cookies.get("rt"));
      }
      bodyFormData.append("mob", data.number);
      bodyFormData.append("otp", data.otp);
      const response = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          "Content-type": "multipart/form-date",
          Accept: "application/json",
          cmd: "otpverify",
        },
      });
      if (response.status === 200) {
        handleVerificationResponse(response?.data?.login);
        return await response.data;
      } else {
        console.error(`API request failed with status: ${response.status}`);
      }
    }
  };
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);

  const handleClosePrivacy = () => {
    setIsPrivacyOpen(false);
  };

  const handleVerificationResponse = (response) => {
    switch (response?.code) {
      case 0: {
        setLoginMessage("کد وارد شده صحیح نمی باشد.");
        setLoginStatusMessage("");
        break;
      }
      case 1: {
        closeModal();
        console.log(response?.code);
        Cookies.set("guid", response.msg, { expires: 365 });
        // dispatch(login(response));
        // dispatch(login)
        handleGetUserData(response.msg);
      }
    }
  };

  const handleGetUserData = async (guid) => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", guid);
    const response = await axios.post(BASE_URL, bodyFormData, {
      headers: {
        "Content-type": "multipart/form-date",
        Accept: "application/json",
        cmd: "guid",
      },
    });
    if (response.status === 200) {
      // handleVerificationResponse(response.data)
      console.log(response.data.rule);
      if (response?.data?.rule === 0) {
        setIsPrivacyOpen(true);
      }
      dispatch(login(response?.data?.userinfo));
      if (onLogin) {
        onLogin(true);
      }
      return await response.data;
    } else {
      console.error(`API request failed with status: ${response.status}`);
    }
  };

  const handleLoginOnChange = (e) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    setCredentials(numericValue);
  };
  return (
    <>
     
        <PrivacyModal
          isOpen={isPrivacyOpen}
          onRequestClose={handleClosePrivacy}
        />
    
      <Modal
        show={isOpen && !isPrivacyOpen}
        onHide={closeModal}
        onExit={onExit}
        onExited={onExited}
        centered
      >
        <Modal.Header>
          <img
            src={modalLogo}
            alt="ModalLogo"
            className="m-auto maxh-40 mt-2 mb-2 "
          />

          <button className="btn-close" onClick={() => closeModal()} />
        </Modal.Header>
        <Modal.Body
          className="justify-content-center mx-4
            "
        >
          <input
            className={`w-100 p-1 form-control ${isLogin ? "d-none" : ""}`}
            minLength="11"
            maxLength="11"
            type="tel"
            value={credentials}
            placeholder="شماره همراه"
            onChange={(e) => handleLoginOnChange(e)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleLogin(e.target.value);
              }
            }}
            ref={loginRef}
          />
          <input
            className={`w-100 p-1 form-input ${isLogin ? "" : "d-none"}`}
            maxLength="11"
            type="tel"
            placeholder="کد احراز 4 رقمی پیامکی"
            onChange={(e) => handleVerification(e.target.value)}
            ref={verifyRef}
          />
          <p
            className={`w-100 text-danger d-block m-2 fa-bold text-center p-1 ${
              loginMessage === "" ? "d-none" : ""
            }`}
          >
            {loginMessage}
          </p>
          <p
            className={`w-100 text-success d-block m-2 fa-bold text-center p-1 ${
              isLogin && loginStatusMessage === "" ? "d-none" : ""
            }`}
          >
            {loginStatusMessage}
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            variant="primary"
            onClick={() => handleLogin(credentials)}
            className={` ${isLogin ? "d-none" : ""}`}
          >
            ورود
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CustomModal;
